import React, { useState, useEffect, Suspense } from 'react';
import Base from '../base';
import { Alert, Button, Col, Container, Form, Row } from '@themesberg/react-bootstrap';
import LoadingSpinner from '../../components/shared/loaderSpinner';
import { get } from '../../services/back.service';
const FormGeneralInfo = React.lazy(() => import('../../components/forms/inspection/form.infoClient'));

function ModifiyInspection() {
  const [show, setShow] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [id, setId] = useState(0)
  const [number, setNumber] = useState(0)

  useEffect(() => { }, []);

  const localSearch = async () => {
    const respoInfo = await get(`/peritaje/idnumber/${number}`, {});
    if (respoInfo.success) {
      setId(respoInfo.data.id)
      setShow(true)
    }
  }

  const showSuccessMessage = () => {
    setShowAlert(true)
  }

  const handleOnChange = ({ target }) => {
    setShowAlert(false);
    setShow(false);
    setNumber(target.value)
  }

  return (
    <Base>
      <Container style={{ padding: 5 }}>
        {showAlert && <Alert variant="success">Peritaje actualizado correctamente</Alert>}
        <Form>
          <Row>
            <Col>
              <Form.Label>Codigo Peritaje</Form.Label>
              <Form.Control
                name="number"
                value={number}
                type="number"
                className="fw-bold text-uppercase"
                onChange={(e) => handleOnChange(e)}
              />
            </Col>
            <Col>
              <Button
                onClick={localSearch}
                variant="outline-primary"
                className="m-3"
              >
                Buscar
              </Button>
            </Col>
          </Row>
        </Form>
        <Row>
          <Col>
            {show &&
              <Suspense fallback={<LoadingSpinner />}><FormGeneralInfo id={id} forceEnable={true} showSuccessMessage={showSuccessMessage} showResponsable={true} /></Suspense>
            }

          </Col>
        </Row>
      </Container>
    </Base>
  )
}

export default ModifiyInspection;
